import { connect } from 'react-redux';
import { getModalProperties } from '../../../modules/modal/selectors';
import ModalDialog from '../../../components/layout/ModalDialog';

const mapStateToProps = getModalProperties;

export default connect(mapStateToProps)(ModalDialog);
